/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInvestmentTradeEventRequest} from '@cash-web/protos/squareup/cash/portfolios/server/service.pb'
import {GetInvestmentTradeEventResponse} from '@cash-web/protos/squareup/cash/portfolios/server/service.pb'


export const getInvestmentTradeEvent = (request: GetInvestmentTradeEventRequest, options?: CashRequestOptions) => post<GetInvestmentTradeEventRequest, GetInvestmentTradeEventResponse>("/2.0/cash/get-investment-trade-event", request, {...options, rejectOnError: true })